@if (label()) {
  <span class="form-field__label">
    {{ label() }}
  </span>
}

<ng-content />

@if (fieldState()?.value() && caption()) {
  <p class="form-field__caption">{{ caption() }}</p>
}

@if (fieldState()?.invalid() && fieldState()?.touched()) {
  @for (error of fieldState()?.errors(); track $index) {
    <p class="form-field__error">{{ error.message }}</p>
  }
}
